const Platform = {
    getUA(){
        if(typeof window == "undefined")
            return "";
        return window.navigator?.userAgent?.toLowerCase() || ""
    },
    isIOS(){
        return (/(iPhone|iPad|iPod|iOS)/i.test(Platform.getUA()));
    },
    isAndroid(){
        return Platform.getUA().indexOf("Android") > -1 || Platform.getUA().indexOf("Linux") > -1;
    },
    isInApp() {
        if (Platform.getUA().includes('com.xt.app')) {
            return true;
        } else {
            return false;
        }
    },
    isServer(){
        return typeof window == "undefined";
    },
    isWeiXin() {
      var ua = Platform.getUA();
      if (!ua.match(/MicroMessenger/i)) return false;
      return ua.match(/MicroMessenger/i).toString() === "micromessenger";
    }
}
export default Platform;